var RendererTypesEnum = /* @__PURE__ */ ((RendererTypesEnum2) => {
  RendererTypesEnum2["RANGE"] = "RangeType";
  RendererTypesEnum2["RADIO"] = "RadioType";
  RendererTypesEnum2["CHECKBOX"] = "CheckboxType";
  RendererTypesEnum2["SWATCH"] = "SwatchType";
  RendererTypesEnum2["YES_NO"] = "YesNoType";
  RendererTypesEnum2["DEFAULT"] = "CheckboxType";
  return RendererTypesEnum2;
})(RendererTypesEnum || {});
var RendererTypesEnum_default = RendererTypesEnum;
export {
  RendererTypesEnum_default as default
};
